/* Cost Savings Calculator: "One install. Every seat."
   Formula from artifact: SEAT=30*12, INSTALL=5000; plans=n*SEAT; ongoing=plans/8; y1=INSTALL+ongoing. */

import { INSTALL, calcSeatSavings, money } from './aas-assessment'
import { initExitIntent } from './aas-exit-intent'

export function applyCalc(root: ParentNode, n: number): ReturnType<typeof calcSeatSavings> {
  const r = calcSeatSavings(n)
  const range = root.querySelector('[data-aas-calc-range]') as HTMLInputElement | null
  if (range) {
    range.value = String(n)
    range.style.setProperty('--v', `${((n - Number(range.min)) / (Number(range.max) - Number(range.min))) * 100}%`)
  }
  const set = (sel: string, html: string, asHtml = false) => {
    const el = root.querySelector(sel)
    if (!el) return
    if (asHtml) el.innerHTML = html
    else el.textContent = html
  }
  set('[data-aas-calc-n]', `${n}<small>people</small>`, true)
  set('[data-aas-calc-plans]', money(r.plans))
  set('[data-aas-calc-y1]', money(r.y1))
  set('[data-aas-calc-on]', money(r.ongoing))
  set('[data-aas-calc-save]', money(r.yearOneSavings))
  set('[data-aas-calc-save2]', money(r.ongoingSavings))
  const barY1 = root.querySelector('[data-aas-bar-y1]') as HTMLElement | null
  const barOn = root.querySelector('[data-aas-bar-on]') as HTMLElement | null
  if (barY1) barY1.style.setProperty('--w', `${r.barY1}%`)
  if (barOn) barOn.style.setProperty('--w', `${r.barOn}%`)
  return r
}

export function initCalculator(root: ParentNode = document) {
  const range = root.querySelector('[data-aas-calc-range]') as HTMLInputElement | null
  let n = range ? Number(range.value) || 50 : 50
  applyCalc(root, n)
  range?.addEventListener('input', () => {
    n = Number(range.value)
    applyCalc(root, n)
  })

  initExitIntent(root, { primaryHref: '/questionnaire/' })

  return {
    get n() { return n },
    setN(v: number) { n = v; applyCalc(root, n) },
    install: INSTALL,
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCalculator(document), { once: true })
  } else {
    initCalculator(document)
  }
}
